import React, { ReactNode } from 'react';
import ImageEmpty from '@root/assets/empty.png';
import './style.less';

const Empty = ({
  children,
  marginTop,
  marginBottom,
  noIcon,
}: {
  children?: ReactNode;
  marginTop?: string | number;
  marginBottom?: string | number;
  noIcon?: boolean;
}) => {
  return (
    <div className="section-empty" style={{ marginTop, marginBottom }}>
      {!noIcon && (
        <div className="empty-image">
          <img src={ImageEmpty} />
        </div>
      )}
      <div className="empty-desc">{children}</div>
    </div>
  );
};

export default Empty;
